(function() {
    'use strict';

    angular.module('allegro')
        .controller('AllegroSafetyInfoCreateController', AllegroSafetyInfoCreateController);

    AllegroSafetyInfoCreateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroSafetyInformationsDataSrvc',
        'allegroSafetyInformationMessagesConst'
    ];

    function AllegroSafetyInfoCreateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroSafetyInformationsDataSrvc,
        allegroSafetyInformationMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            text: []
        };

        self.account = {};
        self.safetyInformationData = {
            account: null,
            text: ''
        };

        self.getAccount = getAccount;
        self.createSafetyInformation = createSafetyInformation;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function createSafetyInformation() {
            self.loading = true;
            self.safetyInformationData.account = self.account.pk;

            allegroSafetyInformationsDataSrvc.create(self.safetyInformationData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroSafetyInformationMessagesConst.add);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
